export default __webpack_public_path__ + "static/media/loading.bb9e7bf8.png";